import { createSlice } from "@reduxjs/toolkit";
import axios from "../../services/authService";
import { API_ENDPOINTS } from '../../config/apiConfig';

export const deleteScenarioSlice = createSlice({
    name: "deleteScenario",
    initialState: {
        loading: false,
        response: {},
        error: null
    },
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.response = {};
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setResponse: (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const {
    reset,
    setLoading,
    setResponse,
    setError
} = deleteScenarioSlice.actions;

/**
 * Delete a scenario from the database (backend will cascade delete all associated attributes)
 * @param {number} scenarioDbId - The database ID of the scenario to delete
 * @param {string} scenarioType - The scenario type ('inbound' or 'outbound-*')
 */
export const deleteScenarioAsync = (scenarioDbId, scenarioType) => async (dispatch) => {
    dispatch(reset());
    dispatch(setLoading(true));

    try {
        // Determine the parameter name based on scenario type
        const paramName = scenarioType === 'inbound' ? 'inbound_id' : 'outbound_id';

        // Build the URL with query parameter
        const url = `${API_ENDPOINTS.DELETE_SCENARIO}?${paramName}=${scenarioDbId}`;

        // Make the DELETE request
        const response = await axios.delete(url);

        dispatch(setResponse({
            message: "Scenario deleted successfully",
            data: response.data
        }));

        return {
            success: true,
            data: response.data
        };

    } catch (err) {
        const errorMessage = err.response?.data?.message || err.message || "Failed to delete scenario";
        console.error("Error deleting scenario:", errorMessage);
        dispatch(setError(errorMessage));
        return {
            success: false,
            error: errorMessage
        };
    }
};

// Selectors
export const selectDeleteScenarioLoading = (state) => state.deleteScenario.loading;
export const selectDeleteScenarioResponse = (state) => state.deleteScenario.response;
export const selectDeleteScenarioError = (state) => state.deleteScenario.error;

export default deleteScenarioSlice.reducer;
